const steps = [
  {
    n: "1",
    title: "Ankommen & verstehen",
    text: "Wir schauen gemeinsam, wo du gerade stehst und was dich beschäftigt.",
    color: "bg-sage-300 text-sage-700",
  },
  {
    n: "2",
    title: "Einordnen & erkennen",
    text: "Du bekommst Klarheit über deine Situation und ein Gefühl dafür, was für dich wirklich wichtig ist.",
    color: "bg-honey-300 text-honey-600",
  },
  {
    n: "3",
    title: "Gestalten & umsetzen",
    text: "Wir entwickeln Ansätze, die zu dir passen und sich gut in deinen Alltag integrieren lassen.",
    color: "bg-clay-300 text-clay-600",
  },
];

export default function Process() {
  return (
    <section
      id="prozess"
      data-testid="process-section"
      className="relative py-24 md:py-32 bg-sage-50"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="font-mono-fine text-[11px] tracking-[0.28em] uppercase text-sage-600">
            Schritt für Schritt
          </span>
          <h2 className="mt-4 font-display font-light text-4xl md:text-5xl lg:text-[3.75rem] leading-[1] tracking-[-0.03em] text-ink-900">
            Klarheit entsteht <span className="italic font-normal">Schritt für Schritt.</span>
          </h2>
          <p className="mt-6 text-ink-700 leading-relaxed">
            Ein klarer Prozess, der dich vom ersten Gespräch bis zur Umsetzung begleitet.
          </p>
        </div>

        <ol className="grid md:grid-cols-3 gap-6 md:gap-8">
          {steps.map((s) => (
            <li
              key={s.n}
              data-testid={`process-step-0${s.n}`}
              className="relative bg-bone-50 rounded-[1.75rem] p-10 border border-bone-300 text-center hover:shadow-lift hover:-translate-y-1 transition-all duration-500"
            >
              <div className={`w-16 h-16 mx-auto rounded-full flex items-center justify-center font-display text-3xl ${s.color}`}>
                {s.n}
              </div>
              <h3 className="mt-6 font-display font-light text-[1.65rem] leading-[1.1] tracking-[-0.02em] text-ink-900">
                {s.title}
              </h3>
              <p className="mt-3 text-ink-700 text-[15px] leading-relaxed">{s.text}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
